// Splash / "coming soon" screen
// -------------------------------
// Flip `enabled` to true whenever you want to cover the site with a
// full-screen announcement image (e.g. while a new season/redesign is
// about to launch). The site keeps running underneath as normal, but
// becomes completely unusable while this is on — visitors only see
// the image until you flip `enabled` back to false.
//
// 1. Generate your announcement image (include the launch date on it).
// 2. Drop it in client/public/ (e.g. client/public/splash-launch.png).
// 3. Point imageSrc at it below.
// 4. Set enabled: true to turn the splash on, false to turn it off.

const splashConfig = {
  enabled: false,
  imageSrc: "/splash-launch.png",
  imageAlt: "New season launching soon",
};

export default splashConfig;
